import { Flex, Switch, Text } from "@chakra-ui/react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class TLDRDownloadPNGTransparentBackground extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
    };
  }

  render() {
    const { t } = this.props;
    return (
      <Flex justifyContent="space-between" alignItems="center" mb={3} mt={2}>
        <Text fontSize="xs" casing="uppercase">
          {t("export_png_bg")}
        </Text>
        <Switch
          onChange={(e) => this.onSwitchChange()}
          isChecked={this.state.checked}
        />
      </Flex>
    );
  }

  onSwitchChange = () => {
    this.setState({ checked: !this.state.checked });
    this.props.onTransparentBackgroundCheckBoxChange(
      this.state.checked ? false : true
    );
  };
}

TLDRDownloadPNGTransparentBackground.propTypes = {};

export default withTranslation(["navbar"])(
  TLDRDownloadPNGTransparentBackground
);
